export const FORNECEDORES_API_URL = process.env.REACT_APP_FORNECEDORES_API_URL;
export const DOCUMENTS_URL = process.env.REACT_APP_DOCUMENTS_URL;
export const VENDORS_PORTAL_API_URL =
  process.env.REACT_APP_VENDORS_PORTAL_API_URL;
export const COOKIES_DOMAIN = process.env.REACT_APP_COOKIES_DOMAIN;
